/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AggregatedBondTrade,
  AssetClass,
  BlockTradeWithExecution,
  BrokerId,
  ExecutedBondTrade,
  HTTPValidationError,
  NdvrTrade,
} from '../models/index';
import {
    AggregatedBondTradeFromJSON,
    AggregatedBondTradeToJSON,
    AssetClassFromJSON,
    AssetClassToJSON,
    BlockTradeWithExecutionFromJSON,
    BlockTradeWithExecutionToJSON,
    BrokerIdFromJSON,
    BrokerIdToJSON,
    ExecutedBondTradeFromJSON,
    ExecutedBondTradeToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    NdvrTradeFromJSON,
    NdvrTradeToJSON,
} from '../models/index';

export interface GenerateFidelityBondTradesCsvRequest {
    optimizationId: number;
    requestBody: Array<string>;
}

export interface GenerateFidelityEquityTradesCsvRequest {
    optimizationId: number;
    requestBody: Array<string>;
}

export interface GenerateSchwabAggregatedBondTradesRequest {
    optimizationId: number;
    requestBody: Array<string>;
}

export interface GenerateSchwabAggregatedEquityTradesRequest {
    optimizationId: number;
    requestBody: Array<string>;
}

export interface GenerateSchwabBondAllocationFileRequest {
    optimizationId: number;
}

export interface GenerateSchwabEquityAllocationFileRequest {
    optimizationId: number;
}

export interface GenerateSchwabEquityBlockTradesCsvRequest {
    optimizationId: number;
}

export interface GenerateSchwabEquityTradesCsvRequest {
    optimizationId: number;
    requestBody: Array<string>;
}

export interface GetBlocksAndExecutionsRequest {
    optimizationId: number;
    assetClass: AssetClass;
    brokerId?: BrokerId;
}

export interface GetSchwabAggregatedBondTradesRequest {
    optimizationId: number;
}

export interface SaveSchwabExecutedBondTradesRequest {
    optimizationId: number;
    executedBondTrade: Array<ExecutedBondTrade>;
}

export interface SubmitManualNdvrTradesRequest {
    ndvrTrade: Array<NdvrTrade>;
}

/**
 * 
 */
export class TradeExecutionApi extends runtime.BaseAPI {

    /**
     * Generate a CSV with Fidelity Bond allocations to be submitted for execution.
     */
    async generateFidelityBondTradesCsvRaw(requestParameters: GenerateFidelityBondTradesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling generateFidelityBondTradesCsv.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling generateFidelityBondTradesCsv.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/fidelity-bond-trades-csv`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate a CSV with Fidelity Bond allocations to be submitted for execution.
     */
    async generateFidelityBondTradesCsv(requestParameters: GenerateFidelityBondTradesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateFidelityBondTradesCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a CSV with Fidelity equity trades to be submitted for execution.
     */
    async generateFidelityEquityTradesCsvRaw(requestParameters: GenerateFidelityEquityTradesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling generateFidelityEquityTradesCsv.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling generateFidelityEquityTradesCsv.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/fidelity-equity-trades-csv`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate a CSV with Fidelity equity trades to be submitted for execution.
     */
    async generateFidelityEquityTradesCsv(requestParameters: GenerateFidelityEquityTradesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateFidelityEquityTradesCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Schwab aggregated bond trades.
     */
    async generateSchwabAggregatedBondTradesRaw(requestParameters: GenerateSchwabAggregatedBondTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling generateSchwabAggregatedBondTrades.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling generateSchwabAggregatedBondTrades.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/generate-schwab-aggregated-bond-trades`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate Schwab aggregated bond trades.
     */
    async generateSchwabAggregatedBondTrades(requestParameters: GenerateSchwabAggregatedBondTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateSchwabAggregatedBondTradesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Schwab aggregated equity block trades.
     */
    async generateSchwabAggregatedEquityTradesRaw(requestParameters: GenerateSchwabAggregatedEquityTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling generateSchwabAggregatedEquityTrades.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling generateSchwabAggregatedEquityTrades.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/generate-schwab-aggregated-equity-trades`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate Schwab aggregated equity block trades.
     */
    async generateSchwabAggregatedEquityTrades(requestParameters: GenerateSchwabAggregatedEquityTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateSchwabAggregatedEquityTradesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate bond allocation file.
     */
    async generateSchwabBondAllocationFileRaw(requestParameters: GenerateSchwabBondAllocationFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling generateSchwabBondAllocationFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/schwab-bond-allocation-csv`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate bond allocation file.
     */
    async generateSchwabBondAllocationFile(requestParameters: GenerateSchwabBondAllocationFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateSchwabBondAllocationFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate equity block allocation file.
     */
    async generateSchwabEquityAllocationFileRaw(requestParameters: GenerateSchwabEquityAllocationFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling generateSchwabEquityAllocationFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/schwab-equity-allocation-csv`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate equity block allocation file.
     */
    async generateSchwabEquityAllocationFile(requestParameters: GenerateSchwabEquityAllocationFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateSchwabEquityAllocationFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a CSV with Schwab equity block trades to be submitted for execution in the master account.
     */
    async generateSchwabEquityBlockTradesCsvRaw(requestParameters: GenerateSchwabEquityBlockTradesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling generateSchwabEquityBlockTradesCsv.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/schwab-equity-block-trades-csv`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate a CSV with Schwab equity block trades to be submitted for execution in the master account.
     */
    async generateSchwabEquityBlockTradesCsv(requestParameters: GenerateSchwabEquityBlockTradesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateSchwabEquityBlockTradesCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a CSV with Schwab equity trades to be submitted for execution.
     */
    async generateSchwabEquityTradesCsvRaw(requestParameters: GenerateSchwabEquityTradesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling generateSchwabEquityTradesCsv.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling generateSchwabEquityTradesCsv.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/schwab-equity-trades-csv`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Generate a CSV with Schwab equity trades to be submitted for execution.
     */
    async generateSchwabEquityTradesCsv(requestParameters: GenerateSchwabEquityTradesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.generateSchwabEquityTradesCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get block trades with their executions.
     */
    async getBlocksAndExecutionsRaw(requestParameters: GetBlocksAndExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BlockTradeWithExecution>>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling getBlocksAndExecutions.');
        }

        if (requestParameters.assetClass === null || requestParameters.assetClass === undefined) {
            throw new runtime.RequiredError('assetClass','Required parameter requestParameters.assetClass was null or undefined when calling getBlocksAndExecutions.');
        }

        const queryParameters: any = {};

        if (requestParameters.assetClass !== undefined) {
            queryParameters['asset_class'] = requestParameters.assetClass;
        }

        if (requestParameters.brokerId !== undefined) {
            queryParameters['broker_id'] = requestParameters.brokerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/block-trades`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BlockTradeWithExecutionFromJSON));
    }

    /**
     * Get block trades with their executions.
     */
    async getBlocksAndExecutions(requestParameters: GetBlocksAndExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BlockTradeWithExecution>> {
        const response = await this.getBlocksAndExecutionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Schwab aggregated bond trades.
     */
    async getSchwabAggregatedBondTradesRaw(requestParameters: GetSchwabAggregatedBondTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AggregatedBondTrade>>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling getSchwabAggregatedBondTrades.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/schwab-aggregated-bond-trades`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AggregatedBondTradeFromJSON));
    }

    /**
     * Get Schwab aggregated bond trades.
     */
    async getSchwabAggregatedBondTrades(requestParameters: GetSchwabAggregatedBondTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AggregatedBondTrade>> {
        const response = await this.getSchwabAggregatedBondTradesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save Schwab executed bond trades.
     */
    async saveSchwabExecutedBondTradesRaw(requestParameters: SaveSchwabExecutedBondTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling saveSchwabExecutedBondTrades.');
        }

        if (requestParameters.executedBondTrade === null || requestParameters.executedBondTrade === undefined) {
            throw new runtime.RequiredError('executedBondTrade','Required parameter requestParameters.executedBondTrade was null or undefined when calling saveSchwabExecutedBondTrades.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/schwab-executed-bond-trades`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.executedBondTrade?.map(ExecutedBondTradeToJSON),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Save Schwab executed bond trades.
     */
    async saveSchwabExecutedBondTrades(requestParameters: SaveSchwabExecutedBondTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.saveSchwabExecutedBondTradesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit manually created NDVR trades for execution.
     */
    async submitManualNdvrTradesRaw(requestParameters: SubmitManualNdvrTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.ndvrTrade === null || requestParameters.ndvrTrade === undefined) {
            throw new runtime.RequiredError('ndvrTrade','Required parameter requestParameters.ndvrTrade was null or undefined when calling submitManualNdvrTrades.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/trade-orders/manual-trade`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.ndvrTrade?.map(NdvrTradeToJSON),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Submit manually created NDVR trades for execution.
     */
    async submitManualNdvrTrades(requestParameters: SubmitManualNdvrTradesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.submitManualNdvrTradesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
